import { render } from "./BaseGoogle.vue?vue&type=template&id=b3efd320&scoped=true"
const script = {}

import "./BaseGoogle.vue?vue&type=style&index=0&id=b3efd320&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3efd320"]])

export default __exports__